<template>
  <div class="main-wrapper">
    <p class="necessary-bold">
      <span :class="!validateAims() ? 'unvalid-field' : 'valid-field'">➤</span>
      Выберите цели установления деловых отношений с ПАО «РосДорБанк»:
    </p>
    <p>Отметьте все цели планируемого сотрудничества.</p>
    <label v-for="aim in aims" :key="aim.ID">
      <input
        type="checkbox"
        v-model="aim.CHECKED"
        @click="onClickAim()"
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('PLANNING_AIM') != -1
        "
      />
      {{ aim.VALUE }}
    </label>
    <p class="necessary-bold">
      <span :class="!validateCharacter() ? 'unvalid-field' : 'valid-field'"
        >➤</span
      >
      Сведения о предполагаемом характере деловых отношений с {{ bankName }}:
    </p>
    <label v-for="character in characters" :key="character.ID * 100">
      <input
        type="checkbox"
        v-model="character.CHECKED"
        @click="onChoose(character.VALUE)"
        :disabled="
          pageInfo.DISABLED != null &&
            pageInfo.DISABLED.indexOf('PLAN_BUSINESS_PERIOD') != -1
        "
      />
      {{ character.VALUE }}
    </label>
  </div>
</template>

<script>
export default {
  name: "RelationshipWithBank",
  props: { pageName: String, pageInfo: {}, bankName: String },
  data: () => ({
    aims: [],
    characters: [],
    selectedAims: [],
    selectedCharacter: 0,
    sendData: {},
  }),
  methods: {
    onChoose(text) {
      this.characters.forEach((item) => {
        item.VALUE == text
          ? (this.selectedCharacter = item.ID)
          : (item.CHECKED = false);
      });
      this.$emit("updated");
    },
    onClickAim() {
      this.$emit("updated");
    },
    validateCharacter() {
      let isOK = false;
      this.characters.forEach((item) => {
        if (item.CHECKED) isOK = true;
      });
      return isOK;
    },
    validateAims() {
      let isOK = false;
      this.aims.forEach((item) => {
        if (item.CHECKED) isOK = true;
      });
      return isOK;
    },
    createSendData() {
      this.sendData.PLANNING_AIM = [];
      this.aims.forEach((item) => {
        if (item.CHECKED) this.sendData.PLANNING_AIM.push(item.ID);
      });
      this.sendData.PLAN_BUSINESS_PERIOD = this.selectedCharacter;
    },
    validateAll() {
      var msg = "";
      if (!this.validateAims())
        msg +=
          "• Выберите хотя бы одну цель установления деловых отношений<br>";
      if (!this.validateCharacter())
        msg += "• Выберите характер деловых отношений";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        this.createSendData();
        this.$emit("changePageSendData", this.sendData, false);
      }
    },
  },
  created() {
    this.sendData.ID = this.pageInfo.ID;
    this.sendData.INN = this.pageInfo.INN;

    this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
    this.aims = this.pageInfo.PLANNING_AIM;
    this.characters = this.pageInfo.PLAN_BUSINESS_PERIOD;
    this.validateAll();
  },
  updated() {
    this.validateAll();
  },
};
</script>

<style scoped>
.main-wrapper {
  display: flex;
  flex-direction: column;
  text-align: justify;
}
input {
  margin-top: 10px;
}
.necessary {
  color: red;
}
</style>
